
export { getSafeURLParameters } from "/home/runner/work/apollo/apollo/packages/core/utils/dom/src/get-safe-url-parameters/get-safe-url-parameters.ts"